import React from "react";
import { LANDING } from "@/constants/testIds";
import { Instagram, Music, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid={LANDING.footer}
      className="relative bg-[hsl(var(--scrm-bg))] border-t hairline"
    >
      {/* Marquee */}
      <div className="overflow-hidden border-b hairline">
        <div className="flex whitespace-nowrap scrm-marquee py-6 md:py-8">
          {Array.from({ length: 8 }).map((_, i) => (
            <span
              key={i}
              className="font-display uppercase tracking-mega text-[hsl(var(--scrm-cream))]/85 text-5xl md:text-7xl px-8 flex items-center gap-8"
            >
              SCRM CLUB
              <span className="text-[hsl(var(--scrm-cream))]/30">✈</span>
              RARE MOMENTS ONLY
              <span className="text-[hsl(var(--scrm-cream))]/30">✦</span>
            </span>
          ))}
        </div>
      </div>

      {/* Lower */}
      <div className="px-6 md:px-10 py-14 md:py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <img
            src="https://customer-assets.emergentagent.com/job_members-first/artifacts/lyyyf23y_56DD1991-6601-409E-8AFD-CE1882D7AD41.png"
            alt="SCRM S23 brand mark"
            className="h-12 md:h-14 w-auto select-none"
          />
          <div className="font-display uppercase tracking-mega text-2xl md:text-3xl text-[hsl(var(--scrm-cream))] mt-4">
            SCRM CLUB
          </div>
          <p className="font-body text-sm text-[hsl(var(--scrm-cream))]/55 mt-3 max-w-xs leading-relaxed">
            Limited Drops. Rare Moments. Archived Forever.
          </p>
        </div>

        <div className="md:col-span-4">
          <div className="text-[10px] tracking-eyebrow uppercase text-[hsl(var(--scrm-cream))]/45 mb-4">
            Channels
          </div>
          <ul className="space-y-3">
            <li>
              <a
                data-testid={LANDING.footerInstagram}
                href="https://instagram.com"
                target="_blank"
                rel="noreferrer"
                className="group inline-flex items-center gap-3 font-body text-[hsl(var(--scrm-cream))]/85 hover:text-[hsl(var(--scrm-cream))] transition-colors"
              >
                <Instagram className="h-4 w-4" strokeWidth={1.25} />
                <span className="uppercase tracking-[0.18em] text-xs">Instagram</span>
                <span className="text-[hsl(var(--scrm-cream))]/30 group-hover:translate-x-1 transition-transform">
                  →
                </span>
              </a>
            </li>
            <li>
              <a
                data-testid={LANDING.footerTiktok}
                href="https://tiktok.com"
                target="_blank"
                rel="noreferrer"
                className="group inline-flex items-center gap-3 font-body text-[hsl(var(--scrm-cream))]/85 hover:text-[hsl(var(--scrm-cream))] transition-colors"
              >
                <Music className="h-4 w-4" strokeWidth={1.25} />
                <span className="uppercase tracking-[0.18em] text-xs">TikTok</span>
                <span className="text-[hsl(var(--scrm-cream))]/30 group-hover:translate-x-1 transition-transform">
                  →
                </span>
              </a>
            </li>
            <li>
              <a
                data-testid={LANDING.footerContact}
                href="mailto:hello@scrmclub.com"
                className="group inline-flex items-center gap-3 font-body text-[hsl(var(--scrm-cream))]/85 hover:text-[hsl(var(--scrm-cream))] transition-colors"
              >
                <Mail className="h-4 w-4" strokeWidth={1.25} />
                <span className="uppercase tracking-[0.18em] text-xs">Contact</span>
                <span className="text-[hsl(var(--scrm-cream))]/30 group-hover:translate-x-1 transition-transform">
                  →
                </span>
              </a>
            </li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="text-[10px] tracking-eyebrow uppercase text-[hsl(var(--scrm-cream))]/45 mb-4">
            Notice
          </div>
          <p className="font-body text-xs text-[hsl(var(--scrm-cream))]/50 leading-relaxed">
            All capsules are released in small numbered batches. Once sold out, items
            enter the permanent archive and are never re-cut.
          </p>
        </div>
      </div>

      <div className="px-6 md:px-10 py-6 border-t hairline flex flex-col md:flex-row justify-between gap-3">
        <span className="text-[10px] tracking-eyebrow uppercase text-[hsl(var(--scrm-cream))]/40">
          © {new Date().getFullYear()} SCRM CLUB — All rights reserved.
        </span>
        <span className="text-[10px] tracking-eyebrow uppercase text-[hsl(var(--scrm-cream))]/40">
          A Private Members Club
        </span>
      </div>
    </footer>
  );
}
